import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import Paper from "@material-ui/core/Paper";

import useStyles from "./styles";

interface IProps {
  mainTitle: string | React.ReactNode;
  contentNumber: string;
  contentText: string;
  onItemSelect?: (item: unknown) => void;
  onItemUnselect?: (item: unknown) => void;
  classes?: {
    root?: string;
    info?: string;
  };
  selected?: boolean;
  disabled?: boolean;
  variant?: "listItem" | "paper";
}

const SummaryInfo = (props: IProps) => {
  const {
    mainTitle,
    contentNumber,
    contentText,
    selected = false,
    disabled = false,
    variant = "listItem",
    onItemSelect,
    onItemUnselect,
    classes: externalClasses
  } = props;

  const classes = useStyles();

  const itemInfo = (
    <>
      <div className={clsx(externalClasses?.info, classes.itemInfo)}>
        <div className={clsx(classes.itemName, { disabled })}>{mainTitle}</div>
        <div className={classes.content}>{contentNumber}</div>
        <div className={classes.content}>{contentText}</div>
      </div>

      {selected && (
        <IconButton
          className={classes.unselectButton}
          onClick={onItemUnselect}
          size={"small"}
        >
          <CancelIcon />
        </IconButton>
      )}
    </>
  );

  if (variant === "paper") {
    return (
      <Paper className={clsx(externalClasses?.root, classes.paperWrapper)}>
        {itemInfo}
      </Paper>
    );
  }

  return (
    <Button
      className={clsx(externalClasses?.root, classes.listItemWrapper, {
        [classes.selectedListItem]: selected
      })}
      onClick={onItemSelect}
      disabled={disabled}
    >
      {itemInfo}
    </Button>
  );
};

export default React.memo(SummaryInfo);
